export default "__VITE_ASSET__f3f8adc2__"